import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import { motion, useReducedMotion } from 'framer-motion';
import type { ReactNode } from 'react';
import { EASE_OUT, PANE_SECONDS } from './browser-motion';
type BrowserPaneSlotProps = {
  open: boolean;
  /** Fill the chat instead of splitting it. */
  wide: boolean;
  children: ReactNode;
};

/** The pane's half of the split: a CSS fraction of the row, so it follows the chat as it resizes. */
const BrowserPaneSlot = t0 => {
  const $ = _c(10);
  const {
    open,
    wide,
    children
  } = t0;
  const reducedMotion = useReducedMotion();
  if (!open) {
    return null;
  }
  const t1 = wide ? "w-full" : "w-1/2 max-w-[720px]";
  let t2;
  if ($[0] !== t1) {
    t2 = cx("relative h-full shrink-0 overflow-hidden", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      opacity: 0
    };
    t4 = {
      opacity: 1
    };
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  const t5 = reducedMotion ? 0 : PANE_SECONDS;
  let t6;
  if ($[4] !== t5) {
    t6 = {
      duration: t5,
      ease: EASE_OUT
    };
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== children || $[7] !== t2 || $[8] !== t6) {
    t7 = <motion.div className={t2} initial={t3} animate={t4} transition={t6}>{children}</motion.div>;
    $[6] = children;
    $[7] = t2;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  return t7;
};
export default BrowserPaneSlot;